import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

export const withRoutingTracker = (WrappedComponent) => {
  class WithRoutingTracker extends Component {
    constructor(props) {
      super(props)
    }

    _getCurrentFlowSteps = (currentFlow) => {
      switch (currentFlow) {
        case 'deep-seating': {
          return [
            'category',
            'type',
            'set',
            'shape',
            'dimensions',
            'fabric',
            'style',
            'fasteners',
            'filling',
          ]
        }
        case 'pillow': {
          return ['category', 'type', 'dimensions', 'fabric', 'style', 'filling']
        }
        case 'filling-only': {
          return ['category', 'type', 'shape', 'dimensions', 'filling']
        }
        case 'custom-deep-seating': {
          return [
            'category',
            'type',
            'set',
            'dimensions',
            'fabric',
            'style',
            'fasteners',
            'filling',
          ]
        }
        default: {
          return [
            'category',
            'type',
            'shape',
            'dimensions',
            'fabric',
            'style',
            'fasteners',
            'filling',
          ]
        }
      }
    }

    render() {
      const { history, location, match, layout, ...passThroughProps } = this.props
      const { currentFlow } = layout
      let params = location.pathname.split('/').filter(String)
      // remove /cushion-designer from the url
      params.shift()
      let parsedLocation = { pathname: '/' + params.join('/') }
      let paramMap = {}
      const steps = this._getCurrentFlowSteps(currentFlow)
      params.map((param, index) => {
        paramMap[steps[index]] = param.split('-').shift()

        if (steps[index] === 'type') {
          let shape = param.split('-')
          paramMap[steps[index]] = {
            id: shape.shift(),
            custom: !!shape.find((shape) => shape === 'custom'),
          }
        }

        if (steps[index] === 'set') {
          let set = param.split('-')
          paramMap[steps[index]] = {
            id: set.shift(),
            slug: set.join('-'),
          }
        }

        if (steps[index] === 'shape') {
          let shape = param.split('-')
          const id = shape.shift()
          const isMultiShape = paramMap.category === '28' && paramMap.type !== '166'

          if (isMultiShape) {
            const name = shape.splice(0, 2).join('-')

            // Optional `-individually-rounded` belonging to the back shape, before the additionalShapeId
            let individuallyRounded = false
            if (shape[0] === 'individually' && shape[1] === 'rounded') {
              individuallyRounded = true
              shape.splice(0, 2)
            }

            const additionalShapeId = shape.shift() || null

            // Optional `-individually-rounded` belonging to the seat shape, at the end
            let additionalShapeIndividuallyRounded = false
            if (
              shape.length >= 2 &&
              shape[shape.length - 2] === 'individually' &&
              shape[shape.length - 1] === 'rounded'
            ) {
              additionalShapeIndividuallyRounded = true
              shape.splice(-2, 2)
            }

            paramMap[steps[index]] = {
              id,
              name,
              additionalShapeId,
              additionalShapeName: additionalShapeId ? shape.join('-') : null,
              individuallyRounded,
              additionalShapeIndividuallyRounded,
            }
          } else {
            let individuallyRounded = false
            if (
              shape.length >= 2 &&
              shape[shape.length - 2] === 'individually' &&
              shape[shape.length - 1] === 'rounded'
            ) {
              individuallyRounded = true
              shape.splice(-2, 2)
            }

            paramMap[steps[index]] = {
              id,
              name: shape.join('-'),
              additionalShapeId: null,
              additionalShapeName: null,
              individuallyRounded,
              additionalShapeIndividuallyRounded: false,
            }
          }
        }

        if (steps[index] === 'dimensions') {
          paramMap[steps[index]] = param.split('-')
        }

        if (steps[index] === 'fabric') {
          let fabric = param.split('-')
          paramMap[steps[index]] = {
            id: fabric.shift(),
            direction: fabric.shift(),
            name: fabric.join('-'),
          }
        }

        if (steps[index] === 'style') {
          let style = param.split('-')
          paramMap[steps[index]] = {
            styleId: style.shift(),
            fabricId: style.shift(),
            fabricDirection: style.shift(),
            fabricName: style.join('-'),
          }
        }

        if (steps[index] === 'fasteners') {
          let fasteners = param.split('-')

          let fastenerPositioning = fasteners.slice(-2)
          paramMap[steps[index]] = {
            fastenerId: fasteners.shift(),
            fastenersPlacement: {
              checkboxes:
                fasteners[1] === 'none'
                  ? paramMap.category === '28' ||
                    paramMap.type === '11569' ||
                    paramMap.type === '12072'
                    ? '00000000'
                    : '00000'
                  : fastenerPositioning[0],
              mirroredCheckboxes:
                fasteners[1] === 'none'
                  ? paramMap.category === '28' ||
                    paramMap.type === '11569' ||
                    paramMap.type === '12072'
                    ? '00000000'
                    : '00000'
                  : fastenerPositioning[1],
            },
          }
        }
      })

      return (
        <WrappedComponent
          /* eslint-disable-next-line react/jsx-props-no-spreading */
          {...passThroughProps}
          history={history}
          location={parsedLocation}
          match={match}
          currentLocationIndex={params.length}
          params={paramMap}
        />
      )
    }
  }

  WithRoutingTracker.displayName = `WithSubscription(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`
  const mapStateToProps = (state) => ({
    layout: state.layout,
  })
  return withRouter(connect(mapStateToProps)(WithRoutingTracker))
}
